export class AuthorizedService {
  authorizedServiceId?: number;
  clientITProfileId?: number;
  name?: string;
  service?: string;
  authorizationType?: string;
  fedRampPackageId?: string;
  nature?: string;
  impactLevel?: string;
  dataTypes?: string;
  users?: string;
}
